import { _fakeMessage } from './Communication';
import { writeFile } from './Filesystem/Helper';

import utils = egr.wcf.utils;
import { getUUID } from '../utils/Helper';

export function openFile(): void {
    const input: HTMLInputElement = document.createElement('input');
    input.type = 'file';
    input.accept = '.pec,.pbox,.obk';
    input.onchange = async (): Promise<void> => {
        let importPath: string;
        const fileList: FileList | null = input.files;
        if (fileList == null || fileList.length < 1) {
            return;
        }

        // tslint:disable-next-line:egr-no-numeric-literal-after-slice
        const extension: string  = fileList[0].name.split('.').slice(-1)[0].toLocaleLowerCase();
        if (extension === 'pbox') {
            importPath = '/imports/' + getUUID() + '/';
            const promises: Array<Promise<void>> = [];
            let zip: JSZip = new JSZip();
            zip = await zip.loadAsync(fileList[0]);
            zip.forEach((path: string, file: JSZipObject): void => {
                promises.push((async (): Promise<void> => {
                    return writeFile(
                        importPath + path,
                        await file.async('arraybuffer')
                    );
                })());
            });

            await Promise.all<void>(promises);
        } else {
            importPath = '/imports/' + getUUID() + '.' + extension;
            await writeFile(
                importPath,
                await utils.arraybuffer.fromBlob(fileList[0])
            );
        }

        const fileExtension: string | undefined = fileList[0].name.split('.').pop();
        if (utils.string.isNullOrEmpty(fileExtension)) {
            return;
        }
        // ToDo: use  new app api module
        _fakeMessage({
            transaction_id: -1,
            type: 'webaction',
            action: 'openfile',
            arguments: {
                type: fileExtension.toLocaleLowerCase(),
                path: importPath
            }
        });
    };
    input.click();
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/DebugActions.ts